<template>
  <v-navigation-drawer
    class="d-flex flex-column"
    v-model="drawer"
    permanent
    app
    color="grey-lighten-10"
    width="240"
  >
    <!-- LOGO - bigger, on LHS -->
    <v-list-item class="sidebar-header pa-4" nav>
      <template #prepend>
        <v-img
          :src="logo"
          contain
          height="52"
          width="180"
          @click="$router.push({ name: 'AdminCustomers' })"
          class="cursor-pointer"
        />
      </template>
    </v-list-item>
    <v-divider />

    <!-- MENU - Customers visible, room for future items -->
    <v-list class="flex-1 overflow-y-auto" nav density="comfortable">
      <v-list-item
        :to="{ name: 'AdminCustomers' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-domain</v-icon>
        </template>
        <v-list-item-title>Customers</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminAdoption' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-account-heart</v-icon>
        </template>
        <v-list-item-title>Customer Adoption</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminReportTemplates' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-file-document-edit</v-icon>
        </template>
        <v-list-item-title>Report Designer</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminEmailTemplates' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-email-edit</v-icon>
        </template>
        <v-list-item-title>Email Designer</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminFormDesigner' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-form-select</v-icon>
        </template>
        <v-list-item-title>Form Designer</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminVersion' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-tag-multiple</v-icon>
        </template>
        <v-list-item-title>Version Management</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'AdminMobileRescue' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-cellphone-arrow-down</v-icon>
        </template>
        <v-list-item-title>Mobile Rescue</v-list-item-title>
      </v-list-item>
      <v-list-item
        :to="{ name: 'Diagnostics' }"
        router
        link
        exact
        active-color="primary"
      >
        <template #prepend>
          <v-icon color="primary">mdi-cellphone-text</v-icon>
        </template>
        <v-list-item-title>Mobile Diagnostics</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script setup>
import { ref } from "vue";
import logo from "@/assets/images/WaywyserLogo.png";

const drawer = ref(true);
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.sidebar-header {
  min-height: 72px;
}
</style>
